import { CreateSlotsAndSlotProps, TableContainer, TableContainerProps } from '@mui/material';
import { ContentIsland, ContentIslandProps } from './ContentIsland';

export type TableContentIslandSlotProps = CreateSlotsAndSlotProps<
  {
    tableContainer: typeof TableContainer;
  },
  {
    tableContainer: TableContainerProps;
  }
>;

export type TableContentIslandProps = ContentIslandProps & TableContentIslandSlotProps;

export function TableContentIsland({
  children,
  slots,
  slotProps,
  ...props
}: TableContentIslandProps) {
  const TableContainerComponent = slots?.tableContainer ?? TableContainer;

  return (
    <ContentIsland {...props}>
      <TableContainerComponent {...slotProps?.tableContainer}>{children}</TableContainerComponent>
    </ContentIsland>
  );
}
